import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IQueryFilterRange, RangeFilterOption } from '../../models/vehicle-status.model';
import { FormsModule } from '@angular/forms';
import { FormModule } from '@coreui/angular-pro';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-date-range-label',
  standalone: true,
  imports: [
        FormsModule,
        FormModule,
        CommonModule
  ],
  templateUrl: './date-range-label.component.html',
  styleUrl: './date-range-label.component.scss'
})
export class DateRangeLabelComponent {



  
  @Input() model: any;
  @Output() modelChange = new EventEmitter()

  @Input() options: RangeFilterOption[] = [
    { value: IQueryFilterRange.ThisYear, label: "This Year" },
    { value: IQueryFilterRange.ThisMonth, label: "This Month" },
    { value: IQueryFilterRange.PrevMonth, label: "Previous Month" }
  ];
  @Input() title!: string;



  // @Input() set dateModel(value: IQueryFilterRange) {
  //   if (value != undefined) {
  //     switch (value) {
  //       case IQueryFilterRange.PrevMonth:
  //         this.dateModelValue = 'Previous Month'
  //         break;
  //       case IQueryFilterRange.ThisMonth:
  //         this.dateModelValue = 'This Month'
  //         break;
  //       case IQueryFilterRange.Yesterday:
  //         this.dateModelValue = 'Yesterday'
  //         break;
  //       case IQueryFilterRange.ThisWeek:
  //         this.dateModelValue = 'This Week'
  //         break;
  //       case IQueryFilterRange.ThisYear:
  //         this.dateModelValue = 'This Year'
  //         break;
      
  //       default:
  //         this.dateModelValue = 'Today'
  //         break;
  //     }

  //   }
  // }
  
  // dateModelValue = 'Today';



}
